export const regions = [
    { name: 'Brazil', code: 'br', param: 'busca' },
    { name: 'Mexico', code: 'mx', param: 'buscar' },
    { name: 'Worldwide', code: 'us', param: 'search' },
    { name: 'Brazil + Mexico', code: 'br_mx', param: 'search' },
    { name: 'Brazil + Mexico + Worldwide', code: 'br_mx_us', param: 'search' }
];

export const outputTemplates = [
    { name: 'IMDB only', id: 'imdb' },
    { name: 'IMDB + JustWatch', id: 'imdb_justwatch' },
];

export const types = [
    { name: 'Movie', value: 'movie' },
    { name: 'Serie', value: 'show' }
];



export const genres = [
    { name: 'Action', value: 'action' },
    { name: 'Adventure', value: 'adventure' },
    { name: 'Animation', value: 'animation' },
    { name: 'Biography', value: 'biography' },
    { name: 'Comedy', value: 'comedy' },
    { name: 'Crime', value: 'crime' },
    { name: 'Documentary', value: 'documentary' },
    { name: 'Drama', value: 'drama' },
    { name: 'Family', value: 'family' },
    { name: 'Fantasy', value: 'fantasy' },
    { name: 'Film-Noir', value: 'film-noir' },
    { name: 'Game-Show', value: 'game-show' },
    { name: 'History', value: 'history' },
    { name: 'Horror', value: 'horror' },
    { name: 'Music', value: 'music' },
    { name: 'Musical', value: 'musical' },
    { name: 'Mystery', value: 'mystery' },
    { name: 'News', value: 'news' },
    { name: 'Reality-TV', value: 'reality-tv' },
    { name: 'Romance', value: 'romance' },
    { name: 'Sci-Fi', value: 'sci-fi' },
    { name: 'Sport', value: 'sport' },
    { name: 'Talk-Show', value: 'talk-show' },
    { name: 'Thriller', value: 'thriller' },
    { name: 'War', value: 'war' },
    { name: 'Western', value: 'western' }
];

export const countries = [
    { name: 'Afghanistan', value: 'af' },
    { name: 'Åland Islands', value: 'ax' },
    { name: 'Albania', value: 'al' },
    { name: 'Algeria', value: 'dz' },
    { name: 'American Samoa', value: 'as' },
    { name: 'Andorra', value: 'ad' },
    { name: 'Angola', value: 'ao' },
    { name: 'Anguilla', value: 'ai' },
    { name: 'Antarctica', value: 'aq' },
    { name: 'Antigua and Barbuda', value: 'ag' },
    { name: 'Argentina', value: 'ar' },
    { name: 'Armenia', value: 'am' },
    { name: 'Aruba', value: 'aw' },
    { name: 'Australia', value: 'au' },
    { name: 'Austria', value: 'at' },
    { name: 'Azerbaijan', value: 'az' },
    { name: 'Bahamas', value: 'bs' },
    { name: 'Bahrain', value: 'bh' },
    { name: 'Bangladesh', value: 'bd' },
    { name: 'Barbados', value: 'bb' },
    { name: 'Belarus', value: 'by' },
    { name: 'Belgium', value: 'be' },
    { name: 'Belize', value: 'bz' },
    { name: 'Benin', value: 'bj' },
    { name: 'Bermuda', value: 'bm' },
    { name: 'Bhutan', value: 'bt' },
    { name: 'Bolivia', value: 'bo' },
    { name: 'Bosnia and Herzegovina', value: 'ba' },
    { name: 'Botswana', value: 'bw' },
    { name: 'Bouvet Island', value: 'bv' },
    { name: 'Brazil', value: 'br' },
    { name: 'British Indian Ocean Territory', value: 'io' },
    { name: 'British Virgin Islands', value: 'vg' },
    { name: 'Brunei', value: 'bn' },
    { name: 'Bulgaria', value: 'bg' },
    { name: 'Burkina Faso', value: 'bf' },
    { name: 'Burma (Myanmar)', value: 'bumm' },
    { name: 'Burundi', value: 'bi' },
    { name: 'Cambodia', value: 'kh' },
    { name: 'Cameroon', value: 'cm' },
    { name: 'Canada', value: 'ca' },
    { name: 'Cape Verde', value: 'cv' },
    { name: 'Caribbean Netherlands', value: 'bq' },
    { name: 'Cayman Islands', value: 'ky' },
    { name: 'Central African Republic', value: 'cf' },
    { name: 'Chad', value: 'td' },
    { name: 'Chile', value: 'cl' },
    { name: 'China', value: 'cn' },
    { name: 'Christmas Island', value: 'cx' },
    { name: 'Cocos (Keeling) Islands', value: 'cc' },
    { name: 'Colombia', value: 'co' },
    { name: 'Comoros', value: 'km' },
    { name: 'Congo, Republic of the', value: 'cg' },
    { name: 'Congo, Democratic Republic of the', value: 'cd' },
    { name: 'Cook Islands', value: 'ck' },
    { name: 'Costa Rica', value: 'cr' },
    { name: 'Côte d’Ivoire', value: 'ci' },
    { name: 'Croatia', value: 'hr' },
    { name: 'Cuba', value: 'cu' },
    { name: 'Cyprus', value: 'cy' },
    { name: 'Czech Republic', value: 'cz' },
    { name: 'Denmark', value: 'dk' },
    { name: 'Djibouti', value: 'dj' },
    { name: 'Dominica', value: 'dm' },
    { name: 'Dominican Republic', value: 'do' },
    { name: 'Ecuador', value: 'ec' },
    { name: 'Egypt', value: 'eg' },
    { name: 'El Salvador', value: 'sv' },
    { name: 'Equatorial Guinea', value: 'gq' },
    { name: 'Eritrea', value: 'er' },
    { name: 'Estonia', value: 'ee' },
    { name: 'Eswatini', value: 'sz' },
    { name: 'Ethiopia', value: 'et' },
    { name: 'Falkland Islands', value: 'fk' },
    { name: 'Faroe Islands', value: 'fo' },
    { name: 'Fiji', value: 'fj' },
    { name: 'Finland', value: 'fi' },
    { name: 'France', value: 'fr' },
    { name: 'French Guiana', value: 'gf' },
    { name: 'French Polynesia', value: 'pf' },
    { name: 'French Southern Territories', value: 'tf' },
    { name: 'Gabon', value: 'ga' },
    { name: 'Gambia', value: 'gm' },
    { name: 'Georgia', value: 'ge' },
    { name: 'Germany', value: 'de' },
    { name: 'Ghana', value: 'gh' },
    { name: 'Gibraltar', value: 'gi' },
    { name: 'Greece', value: 'gr' },
    { name: 'Greenland', value: 'gl' },
    { name: 'Grenada', value: 'gd' },
    { name: 'Guadeloupe', value: 'gp' },
    { name: 'Guam', value: 'gu' },
    { name: 'Guatemala', value: 'gt' },
    { name: 'Guernsey', value: 'gg' },
    { name: 'Guinea', value: 'gn' },
    { name: 'Guinea-Bissau', value: 'gw' },
    { name: 'Guyana', value: 'gy' },
    { name: 'Haiti', value: 'ht' },
    { name: 'Heard and McDonald Islands', value: 'hm' },
    { name: 'Honduras', value: 'hn' },
    { name: 'Hong Kong', value: 'hk' },
    { name: 'Hungary', value: 'hu' },
    { name: 'Iceland', value: 'is' },
    { name: 'India', value: 'in' },
    { name: 'Indonesia', value: 'id' },
    { name: 'Iran', value: 'ir' },
    { name: 'Iraq', value: 'iq' },
    { name: 'Ireland', value: 'ie' },
    { name: 'Isle of Man', value: 'im' },
    { name: 'Israel', value: 'il' },
    { name: 'Italy', value: 'it' },
    { name: 'Jamaica', value: 'jm' },
    { name: 'Japan', value: 'jp' },
    { name: 'Jersey', value: 'je' },
    { name: 'Jordan', value: 'jo' },
    { name: 'Kazakhstan', value: 'kz' },
    { name: 'Kenya', value: 'ke' },
    { name: 'Kosovo', value: 'xko' },
    { name: 'Kuwait', value: 'kw' },
    { name: 'Kyrgyzstan', value: 'kg' },
    { name: 'Laos', value: 'la' },
    { name: 'Latvia', value: 'lv' },
    { name: 'Lebanon', value: 'lb' },
    { name: 'Lesotho', value: 'ls' },
    { name: 'Liberia', value: 'lr' },
    { name: 'Libya', value: 'ly' },
    { name: 'Liechtenstein', value: 'li' },
    { name: 'Lithuania', value: 'lt' },
    { name: 'Luxembourg', value: 'lu' },
    { name: 'Macau', value: 'mo' },
    { name: 'Madagascar', value: 'mg' },
    { name: 'Malawi', value: 'mw' },
    { name: 'Malaysia', value: 'my' },
    { name: 'Maldives', value: 'mv' },
    { name: 'Mali', value: 'ml' },
    { name: 'Malta', value: 'mt' },
    { name: 'Marshall Islands', value: 'mh' },
    { name: 'Martinique', value: 'mq' },
    { name: 'Mauritania', value: 'mr' },
    { name: 'Mauritius', value: 'mu' },
    { name: 'Mexico', value: 'mx' },
    { name: 'Micronesia', value: 'fm' },
    { name: 'Moldova', value: 'md' },
    { name: 'Monaco', value: 'mc' },
    { name: 'Mongolia', value: 'mn' },
    { name: 'Montenegro', value: 'me' },
    { name: 'Montserrat', value: 'ms' },
    { name: 'Morocco', value: 'ma' },
    { name: 'Mozambique', value: 'mz' },
    { name: 'Myanmar', value: 'mm' },
    { name: 'Namibia', value: 'na' },
    { name: 'Nauru', value: 'nr' },
    { name: 'Nepal', value: 'np' },
    { name: 'Netherlands', value: 'nl' },
    { name: 'New Caledonia', value: 'nc' },
    { name: 'New Zealand', value: 'nz' },
    { name: 'Nicaragua', value: 'ni' },
    { name: 'Niger', value: 'ne' },
    { name: 'Nigeria', value: 'ng' },
    { name: 'Niue', value: 'nu' },
    { name: 'Norfolk Island', value: 'nf' },
    { name: 'North Korea', value: 'kp' },
    { name: 'Northern Mariana Islands', value: 'mp' },
    { name: 'Norway', value: 'no' },
    { name: 'Oman', value: 'om' },
    { name: 'Pakistan', value: 'pk' },
    { name: 'Palau', value: 'pw' },
    { name: 'Palestine', value: 'xpi' },
    { name: 'Panama', value: 'pa' },
    { name: 'Papua New Guinea', value: 'pg' },
    { name: 'Paraguay', value: 'py' },
    { name: 'Peru', value: 'pe' },
    { name: 'Philippines', value: 'ph' },
    { name: 'Pitcairn Islands', value: 'pn' },
    { name: 'Poland', value: 'pl' },
    { name: 'Portugal', value: 'pt' },
    { name: 'Puerto Rico', value: 'pr' },
    { name: 'Qatar', value: 'qa' },
    { name: 'Reunion', value: 're' },
    { name: 'Romania', value: 'ro' },
    { name: 'Russia', value: 'ru' },
    { name: 'Rwanda', value: 'rw' },
    { name: 'Saint Kitts and Nevis', value: 'kn' },
    { name: 'Saint Lucia', value: 'lc' },
    { name: 'Saint Vincent and the Grenadines', value: 'vc' },
    { name: 'Samoa', value: 'ws' },
    { name: 'San Marino', value: 'sm' },
    { name: 'Sao Tome and Principe', value: 'st' },
    { name: 'Saudi Arabia', value: 'sa' },
    { name: 'Senegal', value: 'sn' },
    { name: 'Serbia', value: 'rs' },
    { name: 'Seychelles', value: 'sc' },
    { name: 'Sierra Leone', value: 'sl' },
    { name: 'Singapore', value: 'sg' },
    { name: 'Slovakia', value: 'sk' },
    { name: 'Slovenia', value: 'si' },
    { name: 'Solomon Islands', value: 'sb' },
    { name: 'Somalia', value: 'so' },
    { name: 'South Africa', value: 'za' },
    { name: 'South Georgia and South Sandwich Islands', value: 'gs' },
    { name: 'South Korea', value: 'kr' },
    { name: 'Spain', value: 'es' },
    { name: 'Sri Lanka', value: 'lk' },
    { name: 'Sudan', value: 'sd' },
    { name: 'Suriname', value: 'sr' },
    { name: 'Svalbard and Jan Mayen', value: 'sj' },
    { name: 'Sweden', value: 'se' },
    { name: 'Switzerland', value: 'ch' },
    { name: 'Syria', value: 'sy' },
    { name: 'Taiwan', value: 'tw' },
    { name: 'Tajikistan', value: 'tj' },
    { name: 'Tanzania', value: 'tz' },
    { name: 'Thailand', value: 'th' },
    { name: 'Timor-Leste', value: 'tl' },
    { name: 'Togo', value: 'tg' },
    { name: 'Tokelau', value: 'tk' },
    { name: 'Tonga', value: 'to' },
    { name: 'Trinidad and Tobago', value: 'tt' },
    { name: 'Tunisia', value: 'tn' },
    { name: 'Turkey', value: 'tr' },
    { name: 'Turkmenistan', value: 'tm' },
    { name: 'Turks and Caicos Islands', value: 'tc' },
    { name: 'Tuvalu', value: 'tv' },
    { name: 'Uganda', value: 'ug' },
    { name: 'Ukraine', value: 'ua' },
    { name: 'United Arab Emirates', value: 'ae' },
    { name: 'United Kingdom', value: 'gb' },
    { name: 'United States', value: 'us' },
    { name: 'Uruguay', value: 'uy' },
    { name: 'Uzbekistan', value: 'uz' },
    { name: 'Vanuatu', value: 'vu' },
    { name: 'Vatican City', value: 'va' },
    { name: 'Venezuela', value: 've' },
    { name: 'Vietnam', value: 'vn' },
    { name: 'Western Sahara', value: 'eh' },
    { name: 'Yemen', value: 'ye' },
    { name: 'Zambia', value: 'zm' },
    { name: 'Zimbabwe', value: 'zw' }
];

export const languages = [
    { name: 'Arabic', value: 'ar' },
    { name: 'Bengali', value: 'bn' },
    { name: 'Chinese', value: 'zh' },
    { name: 'English', value: 'en' },
    { name: 'French', value: 'fr' },
    { name: 'German', value: 'de' },
    { name: 'Hindi', value: 'hi' },
    { name: 'Indonesian', value: 'id' },
    { name: 'Japanese', value: 'ja' },
    { name: 'Javanese', value: 'jv' },
    { name: 'Korean', value: 'ko' },
    { name: 'Malay', value: 'ms' },
    { name: 'Marathi', value: 'mr' },
    { name: 'Portuguese', value: 'pt' },
    { name: 'Punjabi', value: 'pa' },
    { name: 'Russian', value: 'ru' },
    { name: 'Spanish', value: 'es' },
    { name: 'Tamil', value: 'ta' },
    { name: 'Telugu', value: 'te' },
    { name: 'Turkish', value: 'tr' },
    { name: 'Urdu', value: 'ur' }
];

export const imdbTypes = [
    { name: 'Movie', value: 'movie' },
    { name: 'TV Series', value: 'tvSeries' },
    { name: 'Short Film', value: 'short' },
    { name: 'TV Episode', value: 'tvEpisode' },
    { name: 'TV Mini-Series', value: 'tvMiniSeries' },
    { name: 'TV Movie', value: 'tvMovie' },
    { name: 'TV Special', value: 'tvSpecial' },
    { name: 'TV Short', value: 'tvShort' },
    { name: 'Video Game', value: 'videoGame' },
    { name: 'Video', value: 'video' },
    { name: 'Music Video', value: 'musicVideo' },
    { name: 'Podcast Series', value: 'podcastSeries' },
    { name: 'Podcast Episode', value: 'podcastEpisode' }
];